import i18n from '../i18n';

/**
 * Funzione per tradurre una chiave
 * @param key - Chiave di traduzione (es: 'common.welcome')
 * @param options - Opzioni di interpolazione (es: { min: 5 })
 */
export const t = (key: string, options?: any): string => {
  return i18n.t(key, options);
};

/**
 * Cambia la lingua corrente
 * @param lang - Codice lingua ('it' o 'en')
 */
export const changeLanguage = (lang: 'it' | 'en'): Promise<any> => {
  return i18n.changeLanguage(lang);
};

/**
 * Ottieni la lingua corrente
 */
export const getCurrentLanguage = (): 'it' | 'en' => {
  return i18n.language as 'it' | 'en';
};

/**
 * Verifica se la lingua corrente è italiano
 */
export const isItalian = (): boolean => {
  return i18n.language === 'it';
};

/**
 * Verifica se la lingua corrente è inglese
 */
export const isEnglish = (): boolean => {
  return i18n.language === 'en';
};

/**
 * Esporta l'istanza i18n per usi avanzati
 */
export { i18n };

